// Cast screen: fill world slots with saved characters first, generate the
// rest. Selection caps at the slot count; nothing generates until Confirm.
// Also picks the starting scenario (dialogue backdrop, not plot).
import { useState } from 'react';
import { SCENARIOS } from '../sim/scenarios.js';
import { loadLibrary } from './library.js';

export default function CastScreen(props: {
  count: number;
  scenarioId: string;
  onScenario: (id: string) => void;
  onBack: () => void;
  onStart: (selectedIds: string[]) => void;
}): JSX.Element {
  const [entries] = useState(() => loadLibrary());
  const [sel, setSel] = useState<string[]>([]);
  const toggle = (id: string): void => {
    setSel((s) => {
      if (s.includes(id)) return s.filter((x) => x !== id);
      if (s.length >= props.count) return s; // slots full
      return [...s, id];
    });
  };
  const generate = props.count - sel.length;
  return (
    <div className="screen screen-wide">
      <h1>Cast Your World</h1>
      <div className="subtitle">
        {sel.length}/{props.count} slots cast{generate > 0 ? ` — ${generate} will be newly generated` : ' — full cast of returners'}.
      </div>
      <strong className="section-label">Starting scenario</strong>
      <div className="cast-list scenario-list">
        {SCENARIOS.map((s) => (
          <button
            key={s.id}
            className={props.scenarioId === s.id ? 'cast-card sel' : 'cast-card'}
            onClick={() => props.onScenario(s.id)}
            title={s.tagline}
          >
            <strong>{s.title}</strong>
            <span className="mut"> · {s.tagline}</span>
            <span className="cast-check">{props.scenarioId === s.id ? '✓' : ''}</span>
          </button>
        ))}
      </div>
      <strong className="section-label">Returning cast</strong>
      {entries.length === 0 && (
        <div className="hint">No saved characters yet — everyone will be freshly generated.</div>
      )}
      <div className="cast-list">
        {entries.map((e) => {
          const on = sel.includes(e.npc.id);
          const full = !on && sel.length >= props.count;
          return (
            <button
              key={e.npc.id}
              className={on ? 'cast-card sel' : 'cast-card'}
              disabled={full}
              onClick={() => toggle(e.npc.id)}
              title={full ? 'Slots full' : on ? 'Remove from cast' : 'Add to cast'}
            >
              <strong>{e.npc.firstName} {e.npc.lastName}</strong>
              <span className="mut"> · {e.npc.origin === 'llm' ? '✦ LLM' : e.npc.origin === 'human' ? '◈ human' : '○ offline'}{e.npc.neurotic ? ' · intense' : ''}</span>
              <span className="cast-check">{on ? '✓' : ''}</span>
            </button>
          );
        })}
      </div>
      <div className="menu-row">
        <button className="btn-ghost" onClick={props.onBack}>Back</button>
        <button className="btn-primary" onClick={() => props.onStart(sel)}>
          {generate > 0 ? `Start World (${generate} new)` : 'Start World'}
        </button>
      </div>
    </div>
  );
}
